import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, NgFor } from '@angular/common';
import { CareerService } from '../services/career.service';
import { CareerResponse } from './models/career-response.model';
import { Career } from './models/career.model';
import { SafeTextPipe } from '../safe-text.pipe';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-career',
  standalone: true,
  imports: [TranslateModule, NgFor, CommonModule, SafeTextPipe],
  templateUrl: './career.component.html',
  styleUrl: './career.component.css'
})
export class CareerComponent {

  careerData: Career[] = [];

  baseApiUrl = environment.baseApiUrl;

  searchTerm: string = '';

  status: string = 'Active';

  pagination = {
    page: 1,
    limit: 50,
    totalPages: 0
  }

  constructor(private careerService: CareerService, private translate: TranslateService) {}
  
  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

  ngOnInit(): void {
    this.loadCareers(this.pagination.page, this.pagination.limit, this.searchTerm, this.status);
  }

  
  loadCareers(page: number, limit: number, searchTerm: string = '', status: String = 'All'): void {
    this.careerService.getCareers(page, limit, searchTerm, status).subscribe(
      (Response: CareerResponse) => {
        this.careerData = Response.data.careers.map(career => ({
          ...career,
        }));


      },
      (error) => {
        console.log('Error fetching careers: ', error);
      }
    )
  }


}
